// SidebarMenu.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // assuming you're using react-router

const SidebarMenu = ({ menus }) => {
    const smenu = useState('');
  return (
    <ul className="sidebar-menu">
  {menus.map(menu => (
    <li key={menu.id} className={menu.children.length > 0 ? "treeview" : ""}>
      <a href={menu.menuUrl}>
        <span
          dangerouslySetInnerHTML={{ __html: menu.menuIcon }}
        />
        <span className="menu-text">{menu.menuName}</span>
      </a>

      {menu.children.length > 0 && (
        <ul className="treeview-menu">
          {menu.children.map(submenu => (
            <li key={submenu.id}>
              <a href={submenu.menuUrl}>{submenu.menuName}</a>
            </li>
          ))}
        </ul>
      )}
    </li>
  ))}
</ul>

  );
};
export default SidebarMenu;